import { reviewBodySlicer } from '.';
import s from '../solution-rate-reviews.scss';
import React from 'react';
import { nameToAvatarFormatter } from './solution-review-title';
import { withMarketplaceStore } from '../../../../../component-decorators/with-marketplace-store';
import { Avatar, Box, Text, TextButton } from '@wix/design-system';
import { composer } from '../../../../../component-decorators/composer';
import type { TFunction } from 'i18next';
import type { ISolutionReviewReply } from '../../../../../types/common/marketplace';

interface ISolutionReviewReplyProps {
  reply: ISolutionReviewReply;
  developerName: string;
  developerIcon: string;
  isMobile: boolean;
}

@withMarketplaceStore
export class ReviewReply extends React.Component<
  ISolutionReviewReplyProps,
  any
> {
  constructor(props) {
    super(props);
    this.state = {
      isLongReview: this.isBodyTooLong(this.props.reply.description),
      expandedBody: false,
    };
    this.getReviewBodyText = this.getReviewBodyText.bind(this);
    this.expandToggle = this.expandToggle.bind(this);
  }

  isBodyTooLong(body: string) {
    return body && body.split(' ').length > 34;
  }

  getReviewBodyText() {
    return this.state.isLongReview && !this.state.expandedBody
      ? reviewBodySlicer(this.props.reply.description)
      : this.props.reply.description;
  }

  expandToggle() {
    this.setState((prevState) => {
      return {
        expandedBody: !prevState.expandedBody,
      };
    });
  }

  render() {
    return (
      <Box className={s.replayContainer}>
        <Avatar
          name={nameToAvatarFormatter(this.props.developerName)}
          imgProps={{ src: this.props.developerIcon }}
          size={this.props.isMobile ? 'size30' : 'size48'}
        />
        <Box
          marginLeft={this.props.isMobile ? '6px' : '18px'}
          direction="vertical"
        >
          <Text className={s.reviewReplyTitle} size="small" weight="normal">
            <TranslatedKey
              tkey="solution.page.review.reply.team"
              data={{
                developer: this.props.developerName,
              }}
            />
          </Text>
          <Text
            dataHook={`review-${this.props.reply.id && this.props.reply.id}`}
            className={s.reviewBody}
            size={this.props.isMobile ? 'small' : 'medium'}
            weight="thin"
          >
            {this.getReviewBodyText()}
          </Text>
          {this.state.isLongReview && (
            <TextButton
              dataHook={`reply-body-expander-${this.props.reply.id}`}
              onClick={this.expandToggle}
            >
              {this.state.expandedBody ? (
                <TranslatedKey tkey="solution.page.review.readLess" />
              ) : (
                <TranslatedKey tkey="solution.page.review.readMore" />
              )}
            </TextButton>
          )}
        </Box>
      </Box>
    );
  }
}

const TranslatedKey = composer()
  .withTranslation()
  .compose(({ t, tkey, data }: { t?: TFunction; tkey: string; data?: any }) =>
    t(tkey, data),
  );
